var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        [
          _c(_vm.component, {
            tag: "component",
            attrs: { documentInfo: _vm.documentInfo },
            on: {
              "update:documentInfo": function ($event) {
                _vm.documentInfo = $event
              },
              "update:document-info": function ($event) {
                _vm.documentInfo = $event
              },
            },
          }),
        ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }